module.exports = __webpack_public_path__ + "img/initial-reader.2ea9bf76.png";